import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'
import Button from '../components/ui/Button'

export default function NotFound() {
  return (
    <div className="min-h-screen bg-pp-ivory flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center px-4"
      >
        <p className="font-display text-8xl lg:text-9xl text-pp-sand mb-4">404</p>
        <h1 className="font-display text-display-md text-pp-ink mb-4">
          Page Not Found
        </h1>
        <p className="text-pp-stone mb-8 max-w-md mx-auto">
          Oops! The page you're looking for doesn't exist. It might have been moved
          or deleted.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button as={Link} to="/">
            <Home className="w-4 h-4" />
            Back to Home
          </Button>
          <Button as={Link} to="/shop" variant="outline">
            <ArrowLeft className="w-4 h-4" />
            Browse Shop
          </Button>
        </div>
      </motion.div>
    </div>
  )
}
